import React, {useEffect, useState} from 'react';
import ListBox from "../../../../ui/ListBox/ListBox";
import {IUserAccessSettings} from "../../../../../app/interfaces/user/IUserAccessSettings";
import {SelectModel} from "../../../../../app/types/SelectModel";
import {useAppDispatch, useAppSelector} from "../../../../../app/store";
import {useDataHelperApi} from "../../../../../app/api/dataHelper";
import {ResponseResultCode} from "../../../../../app/enums/ResponseResultCode";
import {isAxiosError} from "axios";
import {toast} from "react-toastify";
import TagContainer from "../../../../ui/Tag/TagContainer/TagContainer";
import {TagItem, TagItemBackgroundColor} from "../../../../ui/Tag/Tag";
import {selectAccessSettingsDepartments} from "../../../../../features/filter/filterSliceSelectors";
import {setAccessSettings, setAccessSettingsData} from "../../../../../features/filter/filterSlice";

type AccessSettingsDepartmentFilterProps = {
    disabled: boolean;
    settings: IUserAccessSettings;
    isExpanded: boolean;
}

const AccessSettingsDepartmentFilter: React.FC<AccessSettingsDepartmentFilterProps> = ({
                                                                                           disabled,
                                                                                           settings,
                                                                                           isExpanded
                                                                                       }) => {
    const [data, setData] = useState<Array<SelectModel>>([]);
    const departments = useAppSelector(selectAccessSettingsDepartments);
    const dispatch = useAppDispatch();

    const {
        getAccessFilterDepartments: {
            query,
            isLoading
        }
    } = useDataHelperApi();

    useEffect(() => {
        if (departments.length > 0) {
            return;
        }

        (async () => {
            try {
                const response = await query();

                if (response?.data?.resultCode === ResponseResultCode.Ok && response?.data.data) {
                    dispatch(setAccessSettingsData({
                        entity: 'Departments',
                        data: {
                            departments: response.data.data
                        } as any
                    }));
                }
            } catch (e) {
                if (isAxiosError(e)) {
                    toast.error('Unable to load departments list: ' + e.message);
                }
            }
        })();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (data.length > 0 || departments.length <= 0) {
            return;
        }

        setData([...departments]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departments]);

    const onFilter = (value: string | null) => {
        if (!value || value === '') {
            setData([...departments]);
        } else {
            setData([
                ...departments.filter(item => {
                    return item.text.toLowerCase().includes(value.toLowerCase())
                })
            ]);
        }
    }

    return (
        <div style={{margin: '10px 0'}}>
            {isExpanded &&
                <div style={{marginBottom: '5px'}}>
                    <TagContainer id={'access-settings-department-filter-tags'}
                                  width={'100%'}
                                  height={'100px'}
                                  items={settings.departments.filter(e => {
                                      return departments.find(ex => ex.value === e) !== undefined;
                                  }).map((item) => {
                                      let existItem = departments.find(ex => ex.value === item) as SelectModel;

                                      return {
                                          id: `department-tag-${existItem.value}`,
                                          text: existItem.text,
                                          data: existItem,
                                          showClearIcon: true,
                                          backgroundColor: TagItemBackgroundColor.LightGray,
                                          rounded: true
                                      } as TagItem;
                                  })}
                                  onClear={({data}) => {
                                      if (data !== undefined && data !== null) {
                                          let item = data as SelectModel;

                                          dispatch(setAccessSettings({
                                              ...settings,
                                              departments: [
                                                  ...settings.departments.filter(e => e !== item.value)
                                              ]
                                          }));
                                      }
                                  }}/>
                </div>
            }
            <ListBox id={'access-settings-department-filter'}
                     selected={settings.departments.map(item => {
                         return {
                             text: item,
                             value: item
                         }
                     })}
                     disabled={disabled}
                     data={data}
                     isLoading={isLoading}
                     onFilter={onFilter}
                     height={250}
                     selection={'Multiple'}
                     onSelectionChange={(items) => {
                         dispatch(setAccessSettings({
                             ...settings,
                             departments: [...items.map(item => item.value)]
                         }));
                     }}/>
        </div>
    );
};

export default AccessSettingsDepartmentFilter;